export const BOOK_LANGUAGE_VALUES = [
    'English',
    'Danish',
    'German',
    'French',
    'Spanish',
    'Russian',
    'Portuguese',
    'Dutch',
    'Swedish',
    'Norwegian',
    'Finnish',
    'Icelandic',
];

const NATIVE_LANGUAGE_NAMES = {
    en: 'English',
    english: 'English',

    da: 'Dansk',
    danish: 'Dansk',

    de: 'Deutsch',
    german: 'Deutsch',

    fr: 'Français',
    french: 'Français',

    es: 'Español',
    spanish: 'Español',

    ru: 'Русский',
    russian: 'Русский',

    pt: 'Português',
    portuguese: 'Português',

    nl: 'Nederlands',
    dutch: 'Nederlands',

    sv: 'Svenska',
    swedish: 'Svenska',

    nb: 'Norsk',
    no: 'Norsk',
    norwegian: 'Norsk',

    fi: 'Suomi',
    finnish: 'Suomi',

    is: 'Íslenska',
    icelandic: 'Íslenska',
};

export const WEBSITE_LANGUAGE_OPTIONS = [
    { code: 'en', label: NATIVE_LANGUAGE_NAMES.en, flag: '🇬🇧' },
    { code: 'da', label: NATIVE_LANGUAGE_NAMES.da, flag: '🇩🇰' },
    { code: 'sv', label: NATIVE_LANGUAGE_NAMES.sv, flag: '🇸🇪' },
    { code: 'nb', label: NATIVE_LANGUAGE_NAMES.nb, flag: '🇳🇴' },
    { code: 'de', label: NATIVE_LANGUAGE_NAMES.de, flag: '🇩🇪' },
];

export function normalizeLanguageKey(value) {
    return String(value || '').trim().toLowerCase().replace('_', '-').split('-')[0];
}

export function getNativeLanguageName(value, fallback = '') {
    const key = normalizeLanguageKey(value);
    return NATIVE_LANGUAGE_NAMES[key] || String(value || fallback || '').trim();
}
